import React, { FC } from 'react'
import clsx from 'clsx'

interface Props {
	checked: boolean
	onChange?: () => void
	disabled?: boolean
}

/**
 * @component CookieSwitch
 * @description iOS-style toggle switch for cookie consent categories.
 */
const CookieSwitch: FC<Props> = ({ checked, onChange, disabled = false }) => (
	<button
		type="button"
		role="switch"
		aria-checked={ checked }
		onClick={ !disabled ? onChange : undefined }
		className={clsx(
			'relative flex items-center h-6 w-11 rounded-full transition-colors duration-200 shrink-0',
			checked ? (disabled ? 'bg-green-100' : 'bg-green-500') : 'bg-gray-400',
			disabled ? 'cursor-not-allowed' : 'cursor-pointer',
			(checked && !disabled) && 'hover:bg-green-400',
			(!checked && !disabled) && 'hover:bg-gray-300'
		)}
	>
		<span
			className={clsx(
				'absolute h-5 w-5 rounded-full bg-white shadow-sm transition-transform duration-200',
				checked ? 'translate-x-5.5' : 'translate-x-0.5'
			)}
		/>
	</button>
)

export default CookieSwitch
